<div [formGroup]="afGroup">
    <ng-container formArrayName="afs" *ngFor="let af of afGroup.get('afs')['controls']; let i=index;">
        <div [formGroupName]="i" class="form-group">
            <div class="form-label-div">
                <span class="form-label">{{getAFName(af)}}</span>
            </div>
            <div class="form-input-div m-h-36">
                <ng-container [ngSwitch]="af.get('fieldType').value">
                    <ng-container *ngSwitchCase="'MEMO'">
                        <textarea pInputTextarea maxlength="2000" autoResize="autoResize"
                            [appErrorMessage]="af.get('value')"
                            [ngClass]="{'has-error': isError(af) && (af.get('value').dirty || af.get('value').touched)}"
                            formControlName="value">
                    </textarea>
                    </ng-container>
                    <ng-container *ngSwitchCase="'TXT'">
                        <input pInputText maxlength="50" [appErrorMessage]="af.get('value')"
                            [ngClass]="{'has-error': isError(af) && (af.get('value').dirty || af.get('value').touched)}"
                            formControlName="value"/>
                    </ng-container>
                    <ng-container *ngSwitchCase="'DTO'">
                        <p-calendar [appErrorMessage]="af.get('value')" [dateFormat]="dateFormat"
                            [locale]="calenderConfig"
                            [ngClass]="{'has-error': isError(af) && (af.get('value').dirty || af.get('value').touched)}"
                            [showIcon]="true" formControlName="value">
                        </p-calendar>
                    </ng-container>
                    <ng-container *ngSwitchCase="'DT'">
                        <p-calendar [appErrorMessage]="af.get('value')" [dateFormat]="dateFormat"
                            [locale]="calenderConfig"
                            [ngClass]="{'has-error': isError(af) && (af.get('value').dirty || af.get('value').touched)}"
                            [showTime]="true" [showIcon]="true" formControlName="value">
                        </p-calendar>
                    </ng-container>
                    <ng-container *ngSwitchCase="'TMO'">
                        <p-calendar [dateFormat]="dateFormat" [locale]="calenderConfig"
                            [appErrorMessage]="af.get('value')"
                            [ngClass]="{'has-error': isError(af) && (af.get('value').dirty || af.get('value').touched)}"
                            [timeOnly]="true" [showIcon]="true" formControlName="value">
                        </p-calendar>
                    </ng-container>
                    <ng-container *ngSwitchCase="'BOOL'">
                        <p-checkbox class="vertical-center" binary="true" formControlName="value">
                        </p-checkbox>
                    </ng-container>
                    <ng-container *ngSwitchCase="'CBO'">
                        <div class="custom-select form-label-div flex-grow" [appErrorMessage]="af.get('value')">
                            <select 
                                [ngClass]="{'has-error': isError(af) && (af.get('value').dirty || af.get('value').touched)}"
                                formControlName="value">
                                <option value="">{{'vbeiSelect' | translate}}</option>
                                <option *ngFor="let afvalue of af.get('additionalFieldListValues').value"
                                    value="{{afvalue}}">
                                    {{afvalue}}
                                </option>
                            </select>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <input type="text" pInputText maxlength="50" [appErrorMessage]="af.get('value')"
                            [ngClass]="{'has-error': isError(af) && (af.get('value').dirty || af.get('value').touched)}"
                            formControlName="value"/>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </ng-container>
</div>